import api from "../../../services/api";
import { useState } from "react";
import { TextField, Button, Typography, Paper } from "@mui/material";
import PageContainer from '../../../common/components/PageContainer';
import useAlerta from '../../../common/components/useAlerta';
import AppSnackbar from '../../../common/components/AppSnackbar';

function CadastroDocumento() {
    const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
    const [titulo, setTitulo] = useState("");
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState("");

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);
        setFileName(selectedFile ? selectedFile.name : "");
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!titulo || !file) {
            mostrarAlerta("Preencha todos os campos!", "error");
            setTimeout(fecharAlerta, 3000);
            return;
        }

        const formData = new FormData();
        formData.append("titulo", titulo);
        formData.append("arquivo", file);

        try {
            await api.post("/documento", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            mostrarAlerta("Documento cadastrado com sucesso!", "success");
            setTitulo("");
            setFile(null);
            setFileName("");
            setTimeout(() => {
                window.location.href = "/documento";
            }, 1500);
        } catch (error) {
            if (error.response && error.response.status === 403) {
                mostrarAlerta("Você não tem permissão para enviar documentos.", "error");
            } else {
                mostrarAlerta("Erro ao cadastrar documento!", "error");
            }
        }

        setTimeout(fecharAlerta, 3000);
    };

    return (
        <PageContainer sx={{ maxWidth: 600 }}>
            <Paper component="form" onSubmit={handleSubmit} sx={{ p: { xs: 2, sm: 4 }, display: "flex", flexDirection: "column", gap: 2 }}>
                <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600 }} align="center">Upload de Documento</Typography>
                <TextField
                    label="Título"
                    variant="outlined"
                    value={titulo}
                    onChange={(e) => setTitulo(e.target.value)}
                    required
                />
                <Button variant="contained" component="label">
                    Selecionar Arquivo
                    <input type="file" hidden onChange={handleFileChange} />
                </Button>
                {fileName && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        Arquivo: {fileName}
                    </Typography>
                )}
                <Button type="submit" variant="contained" color="secondary">Enviar</Button>
            </Paper>

            <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
        </PageContainer>
    );
}

export default CadastroDocumento;
